import moment from 'moment';

export const date = date => moment(date).format('DD/MM/YYYY')

export const dateTime = date => moment(date).format('DD/MM/YYYY HH:mm')



// WEBPACK FOOTER //
// ./src/utils/format.js